import React from 'react'

function Transition({setShowModal, showModal}) {
    return (
        <div
        className="flex justify-center items-center md:w-full backdrop-blur-[1px] bg-black/40 overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="flex my-6 mx-auto max-w-3xl">
          <div className="rounded-lg shadow-lg p-8  bg-white">
            <div >
                <h1 className="text-center text-zinc-800 text-4xl font-bold ">Transition Successful</h1>
                <p className="rounded-full flex justify-center items-center w-10 h-10 mt-5 mx-auto bg-green-900">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-14 w-14" viewBox="0 0 20 20" fill="white">
                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                </p>
            </div>
          </div>
          <div onClick={() => setShowModal(0)} className="flex ml-3 justify-center ml-3 items-center rounded-full bg-white h-5 w-5">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
            </div>
        </div>
      </div>
    )
}

export default Transition